export default {
  selectedGroup: null,
  selectedGroupsIds: [],
  allGroupsIds: [],
  currentPageFacilitiesGroups: [],
  initiallySelectedFacilitiesGroups: [], // for adding to group dialog purposes
  groupsTotalCount: 0,
  currentPageSelectedGroupFacilities: [],
  selectedGroupSelectedFacilities: [],
  allSelectedGroupFacilitiesIds: [],
  selectedGroupFacilitiesTotalCount: 0
};
